module.exports = __webpack_public_path__ + "static/media/web-rtc-video-chat.5d60bfe6.png";